var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 40,
    viewBox: "0 0 49 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.488 4.77096C46.6773 5.67627 44.8667 5.97804 42.7543 6.27981C44.8667 5.07273 46.3756 3.2621 46.9791 0.847927C45.1685 2.05501 43.0561 2.65856 40.6419 3.2621C38.8313 1.45147 36.1153 0.244385 33.3994 0.244385C27.0622 0.244385 22.2338 6.27981 23.7427 12.3152C15.5949 12.0135 8.35236 8.09045 3.22224 2.05501C0.5063 6.58159 2.01516 12.3152 6.23996 15.333C4.7311 15.333 3.22224 14.7294 1.71339 14.1259C1.71339 18.6524 5.03287 22.8772 9.55945 24.0843C8.05059 24.3861 6.54173 24.6879 5.03287 24.3861C6.23996 28.3091 9.86122 31.3268 14.3878 31.3268C10.7665 34.0428 5.33464 35.5517 0.204529 34.9481C4.7311 37.6641 9.86122 39.4747 15.2931 39.4747C33.7012 39.4747 43.9614 24.0843 43.3578 9.90107C45.4702 8.69399 47.2809 6.88336 48.488 4.77096Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.95af0c7ce01233ed4204e3cb45f7e1a6.svg";
export { ForwardRef as ReactComponent };